<template>
  <div :class="['page-frame', 'flex', 'column', { safe: isSafeBottom }]">
    <div
      v-if="showPaddingTop && viewPaddingTop && !showPageError.show"
      :style="{
        height: `${viewPaddingTop}px`,
        background: headerColor || '#fff',
      }"
    ></div>
    <div v-if="isShowNav">
      <van-nav-bar
        class="header-nav"
        :background="headerColor"
        v-bind="$attrs"
        v-on="$listeners"
        @click-left="onBack"
        left-arrow
      >
        <template #left>
          <icon-font
            style="font-size: 24px; vertical-align: middle"
            icon-name="iconfanhui"
          />
        </template>
        <template #right v-if="rightText">
          <icon-font
            v-if="rightText === 'icon'"
            @click.native="onShare"
            style="font-size: 24px; vertical-align: middle"
            icon-name="iconfenxiang"
          />
          <span v-else>{{ rightText }}</span>
        </template>
        <slot name="navRight" />
      </van-nav-bar>
    </div>
    <slot name="top" />
    <div
      class="page-main flex-1"
      ref="pageMain"
      @scroll="scroll"
      v-if="!showPageError.show"
    >
      <van-pull-refresh
        :value="isLoading"
        @input="changeLoading"
        @refresh="refresh"
        :disabled="!usePullRefresh"
        v-if="usePullRefresh"
      >
        <slot />
      </van-pull-refresh>
      <slot v-else />
    </div>
    <slot name="footer" v-if="showFixedBottomTab && !showPageError.show" />
    <error-page
      v-if="showPageError.show"
      :errorType="showPageError.type"
      :errorMessage="showPageError.message"
    />

    <slot name="extra" />
    <div
      class="back-to-top"
      v-if="showReturnTop && backTop"
      @click="onReturnTopClick"
    />
  </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto';
import { NavBar as VanNavBar } from '@zyf2e/capui-mobile';
import ErrorPage from './error/index.vue';

export default {
  components: {
    ErrorPage,
    VanNavBar,
  },

  props: {
    showFixedBottomTab: {
      type: Boolean,
      default: false,
    },
    isSafeBottom: {
      type: Boolean,
      default: true,
    },
    showPaddingTop: {
      type: Boolean,
      default: true,
    },
    showNav: {
      type: Boolean,
      default: true,
    },
    backTop: {
      type: Boolean,
      default: false,
    },
    historyBack: {
      type: Boolean,
      default: true,
    },
    headerColor: {
      type: String,
      default: '',
    },
    isLoading: Boolean,
    usePullRefresh: {
      type: Boolean,
      default: false,
    },
    showPageError: {
      type: Object,
      default: () => ({
        show: false,
        type: 'network',
        message: '',
      }),
    },
    rightText: {
      type: String,
      default: '',
    },
    shareData: {
      type: Object,
      default: () => ({}),
    },
    recordScroll: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      showReturnTop: false,
      lastPositionTop: 0,
    };
  },
  activated() {
    const contain = this.$refs.pageMain;
    if (contain && this.recordScroll) {
      contain.scrollTop = this.lastPositionTop;
    }
  },
  deactivated() {
    const contain = this.$refs.pageMain;
    if (contain && this.recordScroll) {
      this.lastPositionTop = contain.scrollTop;
    }
  },

  // watch: {
  //   showPageError: {
  //     handler(value) {
  //       if (value.show && this.env.inAPP && !this.showNav) {
  //         Sailer.showNavBar();
  //       }
  //     },
  //     deep: true,
  //   },
  // },

  mounted() {
    this.showReturnTop = false;
  },

  computed: {
    viewPaddingTop() {
      return this.adapter.getPaddingTop();
    },
    isShowNav() {
      return this.env.inAPP && this.showNav;
    },
  },

  methods: {
    onBack() {
      if (this.historyBack) {
        this.adapter.goBack();
      }
      this.$emit('onBack');
    },
    refresh() {
      this.$emit('refresh');
    },
    changeLoading(newIsLoading) {
      this.$emit('update:isLoading', newIsLoading);
    },
    scroll(ev) {
      const { scrollTop, offsetHeight } = ev.target;
      this.showReturnTop = scrollTop >= 2 * offsetHeight;
      this.$emit('scroll', scrollTop, offsetHeight);
    },
    onReturnTopClick() {
      VueScrollTo.scrollTo(this.$refs.pageMain, {
        container: this.$refs.pageMain,
        duration: 300,
        offset: 0,
      });
    },
    onShare() {
      const imageUrl =
        'https://static.91jkys.com/activity/img/d24024def7c641d3b67f5d894b61ecce.png';
      this.adapter.openShare({
        title: '智云健康',
        link: window.link,
        imageUrl,
        miniprogram: {
          userName: process.env.ZY_APPID,
          path: `pages/common/webview?url=${encodeURIComponent(window.lin)}`,
          title: '智云健康',
          imageUrl,
          webPageUrl: window.link,
          desc: this.shareData.content,
          ...this.shareData,
        },
        ...this.shareData,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.page-frame {
  height: 100vh;
  width: 100%;
  background: #fff;
  .header-nav {
    color: #333;
  }
  .page-main.flex-1 {
    -webkit-overflow-scrolling: touch;
    overflow: auto;
  }
  .back-to-top {
    position: fixed;
    z-index: 999;
    right: 16px;
    bottom: 90px;
    width: 44px;
    height: 44px;
    background-image: url(https://static.91jkys.com/activity/img/05bf27e788ef43649647803f7d3f314a.FUp_4649689339972799444_);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
}
.safe {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
</style>
